<template>
  <div>

     <data-table
      :items="items"
      v-on:updateData="getLogs"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
       
      </template>

      <template v-slot:headings>
       <div class="col-md-3">Time</div>
                  <div class="col-md-3">Name</div>
                  <div class="col-md-3">Id</div>
                  <div class="col-md-2">Description</div>
                  <div class="col-md-1 text-right">Details</div>
      </template>

      <template v-slot:rows="slotProps">
         <div class="col-md-3 my-auto">
                    <p class="m-0 font-weight-bold">{{ moment(new Date(slotProps.item.created_at)).format("DD MMM YY,HH:mm:ss")}}</p>
                  </div>

                  <div class="col-md-3 my-auto">
                    <b-badge variant="info" class="m-0">{{ slotProps.item.log_name }}</b-badge>
                  </div>

                   <div class="col-md-3 my-auto">
                    {{ slotProps.item.subject_id }}
                  </div>

                  <div class="col-md-2 my-auto">
                    {{ slotProps.item.description }}
                  </div>

                  <div class="col-md-1 text-right my-auto">
                    <router-link
                      v-b-tooltip.hover
                      title="view"
                      :to="{name: 'user-logs-show-details',params: { id:id, logId:slotProps.item.id }}"
                      class="text-info table-action-icon"
                    >
                      <i class="lni lni-search-alt"></i>
                    </router-link>
                  </div>
      </template>
    </data-table>
 


   
  </div>
</template>

<script>
import userLogRepo from "@/api/repos/userLogRepo";
import dataTable from "@/components/common/DataTable";

export default {
 components: {
    dataTable: dataTable,
  },

  data() {
    return {
      isLoad: false,
      sort: { column: "id", label: "Id Desc", order: "desc" },
      sortOptions: [
        { column: "id", label: "Id Asc", order: "asc" },
        { column: "id", label: "Id Desc", order: "desc" },
        { column: "created_at", label: "Newest", order: "asc" },
        { column: "created_at", label: "Oldest", order: "desc" }
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getLogs({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });  
  },

  props: ["id"],

  methods: {
   
    async getLogs(e) {
      this.isLoad = true;
      try {
        let { data } = await userLogRepo.get(
          this.id,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.logs.data;
        this.totalRows = data.logs.total;
        this.page = data.logs.current_page;
        this.fromRow = data.logs.from;
        this.toRow = data.logs.to;
        this.lastPage = data.logs.last_page;

      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },   
    

  },

  watch: {
    search() {
      this.searchQuery();
    },
       
  }
};
</script>
